// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import DynamicFormSettingsSchema from './dynamic-form-settings-schema';
import DynamicFormFieldDefinitionSchema from './dynamic-form-field-definition-schema';

const schema = {
  $id: '/dynamic-form-definition-schema',
  type: 'object',
  required: [],
  properties: {
    id: {
      type: 'string',
      nullable: true,
    },
    caption: {
      type: 'string',
      nullable: true,
    },
    settings: {
      ...DynamicFormSettingsSchema,
    },
    fields: {
      type: 'array',
      nullable: true,
      items: { ...DynamicFormFieldDefinitionSchema },
    },
  },
} as IJSONSchema;

export default schema;
